import {CertificateFormField} from "../types/certificate-modal.types";
import {Validators} from "@angular/forms";

export const certificateFormFields: Array<CertificateFormField> = [
  {
    fieldName: 'certificateNumber',
    label: 'Номер',
    type: 'text',
    validators: [ Validators.required ]
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    type: 'textarea'
  }
]
